import { withUserGuard } from '@utils/guards/withUserGuard.component'
import { withOrganizationGuard } from '@utils/guards/withOrganizationGuard.component'

import { MobileEditTaskPage } from './mobile.edit-task.page'

export * from './mobile.edit-task.page'

export const GuardEditTaskPage = withUserGuard(withOrganizationGuard()(MobileEditTaskPage))
